import React, { useContext } from 'react'
import { Mail, PhoneCall } from 'lucide-react'
import { GlobalContext } from '../../../contexts/GlobalContext';

export default function () {
	const { clienteRobot } = useContext(GlobalContext)

	const [fone, email] = clienteRobot.footer_content.contatos

	return (
		<section id="contato" className="pb-20 pt-28 px-4 bg-gray-200">
			<div className="container mx-auto">
				<div className="text-center mb-16">
					<h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
						Entre em contato
					</h2>
					<p className="text-lg text-gray-700 max-w-3xl mx-auto">
						Estamos à disposição para te ajudar e sanar possíveis dúvidas!
					</p>
				</div>

				<div className="max-w-3xl mx-auto flex flex-col md:flex-row justify-center gap-8">
					<ContatoItem
						icon={<PhoneCall size={20} className="text-emerald-600" />}
						title="WhatsApp"
						description={fone}
					/>
					<ContatoItem
						icon={<Mail size={20} className="text-emerald-600" />}
						title="Email"
						description={email}
					/>
				</div>
			</div>
		</section>
	)
}

function ContatoItem({ icon, title, description }) {
	return (
		<div className="flex items-start gap-4">
			<div className="text-primary flex-shrink-0 mt-1">{icon}</div>
			<div>
				<h3 className="font-medium text-gray-900 text-lg">{title}</h3>
				<p className="text-gray-700">{description}</p>
			</div>
		</div>
	);
};